import type { CardData } from './types';

// Disposizione a blocchi del mazzo (prototipo 2026-09, modalità 'blocks').
// Il giocatore decide in fase di crafting come dividere le 12 Hand card in
// tre blocchi da 4:
//   - table : le carte che partono sul tavolo (2 per dropzone, a caso quali)
//   - hand1 : la mano del primo giro
//   - hand2 : la mano del secondo giro
// Convenzione di rappresentazione: le Hand card nell'ORDINE del mazzo sono
// [table×4, hand1×4, hand2×4]. Le Mission card sono escluse dal conteggio
// (restano casuali: una in gioco, una scartata).
export const LAYOUT_BLOCK_SIZE = 4;

export interface DeckLayout {
  table: CardData[];
  hand1: CardData[];
  hand2: CardData[];
}

export function splitLayout(cards: CardData[]): DeckLayout | null {
  const hand = cards.filter(c => c.type === 'Hand');
  if (hand.length !== LAYOUT_BLOCK_SIZE * 3) return null;
  return {
    table: hand.slice(0, 4),
    hand1: hand.slice(4, 8),
    hand2: hand.slice(8, 12),
  };
}

// Inverso di splitLayout: ricompone il mazzo ordinato (missioni in coda).
export function composeLayout(layout: DeckLayout, missions: CardData[]): CardData[] {
  return [...layout.table, ...layout.hand1, ...layout.hand2, ...missions];
}

// Disposizione di default "ragionevole" (mazzi starter, mazzi nuovi, bot).
// Regole ricavate dalle simulazioni (docs/layout_experiment.md):
//   - sul tavolo vanno carte SENZA effetti (gli effetti rendono in mano; le
//     bombe sul tavolo dal turno 0 sono il caso peggiore), preferendo valori
//     bassi;
//   - le altre 8 si alternano tra mano 1 e mano 2 in ordine di valore
//     decrescente, così le due mani hanno forza simile.
// È solo un punto di partenza: la disposizione è una scelta del giocatore.
export function suggestLayout(cards: CardData[]): CardData[] {
  const hand = cards.filter(c => c.type === 'Hand');
  const missions = cards.filter(c => c.type === 'Mission');
  if (hand.length !== LAYOUT_BLOCK_SIZE * 3) return cards.slice();
  const hasFx = (c: CardData) => (c.effects?.length ?? 0) > 0;
  const tableOrder = hand.slice().sort((a, b) =>
    Number(hasFx(a)) - Number(hasFx(b)) || a.value - b.value || a.id.localeCompare(b.id));
  const table = tableOrder.slice(0, LAYOUT_BLOCK_SIZE);
  const rest = hand
    .filter(c => !table.includes(c))
    .sort((a, b) => b.value - a.value || a.id.localeCompare(b.id));
  const hand1: CardData[] = [];
  const hand2: CardData[] = [];
  rest.forEach((c, i) => ((i % 4 === 0 || i % 4 === 3) ? hand1 : hand2).push(c));
  return composeLayout({ table, hand1, hand2 }, missions);
}
